import useSWR from 'swr';
import { fetchEndpointData } from '@/utils/fetch.client';

export interface UserSession {
  id: string;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
  current: boolean;
}

interface ListSessionsResponse {
  sessions: UserSession[];
}

export interface RevokeSessionResponse {
  revoked: string;
  currentSession: boolean;
}

export function useUserSessions() {
  const { data, mutate, isLoading, error } = useSWR('/api/v1/user/sessions', () =>
    fetchEndpointData<ListSessionsResponse>('/api/v1/user/sessions'),
  );
  return { sessions: data?.sessions ?? [], mutate, isLoading, error };
}

export async function revokeSession(id: string) {
  return fetchEndpointData<RevokeSessionResponse>(`/api/v1/user/sessions/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}
